/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { ServiceRequest } from "@src/app/model/serviceRequest";
import { TenantService } from '@src/app/shared/tenant.service';
import { UnreadChart } from "@src/app/modules/agent/agent-dashboard-page/UnreadChart";
import { ServiceRequestPageNavRoute } from "@src/app/routes/service-request-page-nav";

export class OverdueRequestsChart extends UnreadChart {
    dataUrl = TenantService.ajaxPath + 'agent/dashboard/overdueReqs';
    title = "My Overdue Requests";

    getSubTitle() {
        return super.getSubTitle($localize`Requests planned to complete on or before today`);
    }

    clickEvent() {
        const url = ServiceRequestPageNavRoute.getListRouteName();
        const params = { ownedById: this.dataUserId, completedAt: '', subStatus: 'overdue', srStatus: ServiceRequest.srOpen.id };

        this.router.navigate([url, params]);
    }
}
